import React, { useState } from "react";
import shapeComponent from "../../assets/images/shape-component.svg";
import APIService from "../../utils/APIService";
import { toast } from "react-toastify";
import twitter from "../../assets/images/twitter2.png";
import facebook from "../../assets/images/facebook3.png";
import linkdin from "../../assets/images/linkdin2.png";
import appPlay from "../../assets/images/app-play.svg";
import googlePlay from "../../assets/images/google-play.svg";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/he1.svg";
import logohover from "../../assets/images/he2hover.svg";
const Footer = () => {
  const [email, setEmail] = useState("");
  let navigate = useNavigate();
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      email: email,
    };

    let res = await APIService.post("/waitlist", payload);
    if (res.message) {
      toast.error(res.message);
    } else {
      toast.success("Your email has been registered");
    }
    setEmail("");
  };

  const redirectToSection = (event, id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="footer-main">
              <Link className="logo" to="/">
                <img src={logo} alt="Happy Ending" className="happy-logo" />
                <img src={logohover} alt="Happy Ending" className="happy-logo2" />
                Happy Ending
              </Link>
              <p>Happy Ending ensures clients stay informed, engaged, and accountable—so you can deliver projects on time, profitably, and stress-free.</p>
              <div className="play-btn-group">
                <a href="#"> <img src={appPlay} alt="appPlay" /></a>
                <a href="#"> <img src={googlePlay} alt="googlePlay" /></a>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-12">
            <div className="footer-main">
              <span>Product</span>
              <Link className="nav-link" to={"/features"}>Features</Link>
              <Link className="nav-link" to={"/how-it-works"}>How It Works</Link>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-12">
            <div className="footer-main">
              <span>Company</span>
              <Link className="nav-link" to={"/aboutus"}>About Us</Link>
              {/* <Link className="nav-link">Our Partners</Link>
              <Link className="nav-link">Career</Link> */}
              <Link className="nav-link" to={"/contact-us"}>Contact Us</Link>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-12">
            <div className="footer-main">
              <span>Resources</span>
              <Link className="nav-link" to={"/bloglist"}>
                Blog
              </Link>
              <Link className="nav-link" to={"/pricing"}>Pricing</Link>
              <Link className="nav-link" to={"/faq"}>FAQ</Link>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-sm-12">
            <div className="footer-main">
              <span>Follow Us</span>
              <a href="#">LinkedIn</a>
              <a href="#">Twitter</a>
              <a href="#">Instagram</a>
              <a href="#">Facebook</a>
              <a href="#">YouTube</a>
            </div>
          </div>

        </div>


      </div>
      <div className="copyright">
        <div className="container">
          <div className="copyright-content">
            <div className="row">
              <div className="col-lg-8 col-md-8 col-sm-12">
                <ul className="privacy-policy">
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-and-conditions">
                      Terms & Conditions
                    </Link>
                  </li>
                  {/* <li>
                    <a href="#">Cookie Policy</a>
                  </li> */}
                </ul>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="happyending-copyright">
                  <p>© Happyending 2025</p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
